<div
  class="hx-drawer-container"
  [class.hx-drawer-container--over]="isOverMode()"
  [class.hx-drawer-container--push]="isPushMode()"
  [class.hx-drawer-container--side]="isSideMode()">
  <aside
    class="hx-drawer"
    [class.hx-drawer--closed]="!isOpened()"
    [class.hx-drawer--collapsed]="collapsedState()"
    [class.hx-drawer--end]="isEndPosition()"
    [class.hx-drawer--opened]="isOpened()"
    [class.hx-drawer--over]="isOverMode()"
    [class.hx-drawer--push]="isPushMode()"
    [class.hx-drawer--radius-all]="borderRadius() === 'all'"
    [class.hx-drawer--radius-left]="borderRadius() === 'left'"
    [class.hx-drawer--radius-none]="borderRadius() === 'none'"
    [class.hx-drawer--radius-right]="borderRadius() === 'right'"
    [class.hx-drawer--side]="isSideMode()"
    [class.hx-drawer--start]="isStartPosition()">
    @if (showHeader()) {
      <div class="hx-drawer__header">
        <div class="hx-drawer__header-content">
          <ng-content select="[hx-header-content]" />
        </div>
      </div>
    }

    @if (showToggle()) {
      <button
        class="hx-drawer__toggle"
        type="button"
        [attr.aria-expanded]="isOverMode() || isPushMode() ? isOpened() : !collapsedState()"
        [attr.aria-label]="'Toggle navigation'"
        [class.hx-drawer__toggle--always-visible]="true"
        [class.hx-drawer__toggle--collapsed]="isOverMode() || isPushMode() ? !isOpened() : collapsedState()"
        (click)="_handleToggle()">
        <hx-icon
          class="hx-drawer__toggle-icon"
          [fontIcon]="isOverMode() || isPushMode() ? (isOpened() ? 'x' : 'chevron-right') : 'chevron-right'" />
      </button>
    }

    <nav aria-label="Main navigation" class="hx-drawer__content" [attr.tabindex]="autoFocus() ? null : -1">
      <ng-content />
    </nav>

    @if (showFooter()) {
      <div class="hx-drawer__footer">
        <ng-content select="[hx-footer-content]" />
      </div>
    }
  </aside>

  @if ((isOverMode() || isPushMode()) && isOpened()) {
    <div class="hx-drawer-backdrop" [attr.aria-hidden]="true" (click)="_closeDrawer()"></div>
  }

  <div class="hx-drawer-content">
    <ng-content select="[hx-content]" />
  </div>
</div>
